import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { notificationsApi } from '@rentflowdev/api'

import { getRealtimeSocket } from './realtime-socket'

// Глобальная подписка на личные нотификации. Сбрасывает кеш — UI повторно
// тянет список + unread badge. Toast'ы — отдельный layer (toast-store), сейчас
// не дёргаем чтобы не плодить шум.
export function useRealtimeNotifications(): void {
	const dispatch = useDispatch()

	useEffect(() => {
		const socket = getRealtimeSocket()

		const invalidate = () => {
			dispatch(notificationsApi.util.invalidateTags(['Notification', 'UnreadCount']))
		}

		socket.on('notification.received', invalidate)

		return () => {
			socket.off('notification.received', invalidate)
		}
	}, [dispatch])
}
